import { IEcommerceQuestionSchema } from '../../types.ts'
import style from './Breadcrumbs.module.scss'

interface IBreadcrumbsProps {
  schema: IEcommerceQuestionSchema
  current: string
  onBack: () => void
}

// {search} / {current page} — the first segment returns to the grid.
const Breadcrumbs = ({ schema, current, onBack }: IBreadcrumbsProps) => (
  <nav className={style.breadcrumbs}>
    <span
      className={style.crumbLink}
      onClick={onBack}
      dangerouslySetInnerHTML={{ __html: schema.search_condition || '' }}
    />
    <span className={style.crumbDivider}>/</span>
    <span className={style.crumbCurrent} dangerouslySetInnerHTML={{ __html: current }} />
  </nav>
)

export default Breadcrumbs
